import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const Ctx = /*#__PURE__*/ createContext(null);
export function RfiRecordProvider({ value, children }) {
    return /*#__PURE__*/ _jsx(Ctx.Provider, {
        value: value,
        children: children
    });
}
/** null outside `RfiRecordLayout` or while the RFI is loading. */ export function useRfiRecord() {
    return useContext(Ctx);
}
